import type { VoucherDistributionConfig } from "../types/voucher-distribution-config";

export const isAuthorizationRequired = (config: VoucherDistributionConfig) => {
  return (
    config.authorizationMethod === "external_uid_authorization" || config.authorizationMethod === "email_authorization"
  );
};
